// extracted by mini-css-extract-plugin
export default {"issueTypeTokenContainer":"IssueTypeToken-module__issueTypeTokenContainer--u7mnl","tokenText":"IssueTypeToken-module__tokenText--jTqtr","token":"IssueTypeToken-module__token--QZUId"};